"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchActions = exports.leadIdActions = exports.baseActions = void 0;
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const utils_1 = require("../common/utils");
const fetch_client_1 = require("../common/fetch-client");
exports.baseActions = ["post"];
exports.leadIdActions = ["review", "update"];
const EXTRA_PAYLOAD_MAPPINGS = {
    email: ["emailAddress"],
    phoneNumber: ["phoneHome", "phoneCustom"],
    provinceCode: ["province"],
    postalCode: ["zipCode", "postalCode"],
    position: ["jobTitle"],
};
class FetchActions {
    constructor(baseUrl, leadType, { transformers = {}, fieldMappings = {}, ...options } = {}) {
        this.transformers = transformers;
        this.fieldMappings = fieldMappings;
        this.client = (0, fetch_client_1.fetchClientFactory)(baseUrl, {
            mode: "cors",
            ...options,
        });
        this.leadType = leadType;
    }
    async execute(pathName, body, { transformers = {}, fieldMappings = {}, ...options } = {}) {
        /** Transformers to use on payload */
        const useTransformers = {
            ...this.transformers,
            ...transformers,
        };
        /** Field mappings to use on payload */
        const useFieldMappings = {
            ...this.fieldMappings,
            ...fieldMappings,
        };
        if (!Array.isArray(body) && typeof body !== "object") {
            throw new Error("Body must be an object!");
        }
        /* payload transformations */
        const payload = Object.entries(body)
            .reduce((acc, [key, val]) => {
            /* payload value transformations */
            const transformer = (useTransformers.hasOwnProperty(key) &&
                typeof useTransformers[key] === "function"
                ? useTransformers[key]
                : () => val);
            const newVal = transformer(val);
            /* payload key mappings */
            if (useFieldMappings.hasOwnProperty(key) &&
                typeof useFieldMappings[key] === "string") {
                key = useFieldMappings[key] || key;
            }
            /* camelCase → snakeCase transformations on payload keys */
            acc[(0, utils_1.snakeCase)(key)] = newVal;
            if (key in EXTRA_PAYLOAD_MAPPINGS) {
                EXTRA_PAYLOAD_MAPPINGS[key].forEach((field) => {
                    const mappedField = (0, utils_1.snakeCase)(field);
                    if (!(mappedField in acc)) {
                        acc[mappedField] = newVal;
                    }
                });
            }
            return acc;
        }, {});
        const response = await this.client(pathName, {
            method: "POST",
            ...options,
            body: payload,
        });
        /* snakeCase → camelCase on returned values */
        const parsedResponse = Object.entries(response)
            .reduce((acc, [key, val]) => {
            acc[(0, camelCase_1.default)(key)] = val;
            return acc;
        }, {});
        return parsedResponse;
    }
}
exports.FetchActions = FetchActions;
//# sourceMappingURL=FetchActions.js.map